import config from '@/config'; // eslint-disable-line import/extensions
import {
  widgetRoute, widgetEnRoute, panoramaRoute,
} from './widgetRoutes';

export const WIDGET_URL = config.widget.url;
export const GLTF_WIDGET_URL = config.widget.gltfUrl;

export const getRoute = (route, params = {}, baseUrl = config.appUrl) => {
  const url = new URL(route?.path ?? '', baseUrl);
  Object.keys(params).forEach((key) => url.searchParams.set(key, params[key]));
  return url;
};

export const getRouteForWidget = (route, params) => {
  params.env = config.appEnv === 'production' ? 'production' : 'stage';
  return getRoute(route, params, WIDGET_URL);
};

export const getRouteForGltfWidget = (params) => {
  params.env = config.appEnv === 'production' ? 'production' : 'stage';
  return getRoute(null, params, GLTF_WIDGET_URL);
};

export const getPanoramaRoute = (params) => getRouteForWidget(panoramaRoute, params);
export const getWidgetRoute = (params) => getRouteForWidget(widgetRoute, params);
export const getEnWidgetRoute = (params) => getRouteForWidget(widgetEnRoute, params);

export const getGltfWidgetRoute = (params) => getRouteForGltfWidget(params);
